import React from "react";

export default function LandingChoice() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #f6f7fb 0%, #edf0f4 100%)",
      padding: "20px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "system-ui, -apple-system, sans-serif",
    }}>
      <div style={{
        width: "100%",
        maxWidth: 1220,
        background: "#ffffff",
        borderRadius: 24,
        boxShadow: "0 25px 80px rgba(42,5,22,0.10)",
        border: "1px solid #edf0f4",
        padding: "24px 20px 32px",
      }}>

        {/* Top bar */}
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          marginBottom: 20,
          flexWrap: "wrap",
        }}>
          <img src="/Lastwishbox-logo.png" alt="LastWish Box" style={{ height: 44, width: "auto", maxWidth: 200 }} />
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <a href="https://lastwishbox.com/" target="_blank" rel="noreferrer" style={{
              color: "#2a0516", textDecoration: "none", fontWeight: 700, fontSize: 13,
              padding: "8px 12px", borderRadius: 10, border: "1px solid #e5e7eb", background: "#fff",
              whiteSpace: "nowrap",
            }}>Personal Website</a>
            <a href="https://business.lastwishbox.com/" target="_blank" rel="noreferrer" style={{
              color: "#2a0516", textDecoration: "none", fontWeight: 700, fontSize: 13,
              padding: "8px 12px", borderRadius: 10, border: "1px solid #e5e7eb", background: "#fff",
              whiteSpace: "nowrap",
            }}>Business Website</a>
          </div>
        </div>

        {/* Hero */}
        <div style={{ marginBottom: 24 }}>
          <h1 style={{
            margin: 0, color: "#2a0516", fontWeight: 800, lineHeight: 1.1,
            fontSize: "clamp(26px, 5vw, 48px)",
          }}>Choose Your LastWish Box Account</h1>
          <p style={{ margin: "10px 0 0", color: "#6b7280", fontSize: "clamp(14px, 2.5vw, 18px)", lineHeight: 1.6, maxWidth: 700 }}>
            Start a personal plan, set up a business account, or sign in to manage an existing account.
          </p>
        </div>

        {/* Cards */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: 16,
        }}>
          {/* Personal */}
          <div style={{
            borderRadius: 20, padding: "24px 20px",
            background: "linear-gradient(180deg, #fff0ee 0%, #fde8e8 100%)",
            color: "#650202", display: "flex", flexDirection: "column", justifyContent: "space-between",
            minHeight: 240, boxShadow: "0 8px 24px rgba(17,24,39,0.08)",
          }}>
            <div>
              <div style={{ fontSize: 36 }}>👤</div>
              <h2 style={{ margin: "12px 0 8px", fontSize: "clamp(20px, 3vw, 26px)", fontWeight: 800, lineHeight: 1.15 }}>Personal Account</h2>
              <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, opacity: 0.9 }}>
                For individuals storing wishes, messages, documents, and personal legacy plans.
              </p>
            </div>
            <a href="/personal/plans" style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              marginTop: 20, minHeight: 44, padding: "0 16px", borderRadius: 12,
              textDecoration: "none", fontWeight: 800, fontSize: 14,
              background: "#f15822", color: "#ffffff",
            }}>View Personal Plans</a>
          </div>

          {/* Business */}
          <div style={{
            borderRadius: 20, padding: "24px 20px",
            background: "linear-gradient(180deg, #980000 0%, #650202 100%)",
            color: "#ffffff", display: "flex", flexDirection: "column", justifyContent: "space-between",
            minHeight: 240, boxShadow: "0 8px 24px rgba(17,24,39,0.08)",
          }}>
            <div>
              <div style={{ fontSize: 36 }}>🏢</div>
              <h2 style={{ margin: "12px 0 8px", fontSize: "clamp(20px, 3vw, 26px)", fontWeight: 800, lineHeight: 1.15 }}>Business Account</h2>
              <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, opacity: 0.9 }}>
                For organisations, tenant-managed access, business workspaces, and team administration.
              </p>
            </div>
            <a href="/plans" style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              marginTop: 20, minHeight: 44, padding: "0 16px", borderRadius: 12,
              textDecoration: "none", fontWeight: 800, fontSize: 14,
              background: "#ffffff", color: "#650202",
            }}>View Business Plans</a>
          </div>

          {/* Login */}
          <div style={{
            borderRadius: 20, padding: "24px 20px",
            background: "linear-gradient(180deg, #eef2f7 0%, #e4eaf2 100%)",
            color: "#003353", display: "flex", flexDirection: "column", justifyContent: "space-between",
            minHeight: 240, boxShadow: "0 8px 24px rgba(17,24,39,0.08)",
          }}>
            <div>
              <div style={{ fontSize: 36 }}>🔐</div>
              <h2 style={{ margin: "12px 0 8px", fontSize: "clamp(20px, 3vw, 26px)", fontWeight: 800, lineHeight: 1.15 }}>Log In</h2>
              <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, opacity: 0.9 }}>
                Access your personal account, business account, or any managed access you already have.
              </p>
            </div>
            <a href="/login" style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              marginTop: 20, minHeight: 44, padding: "0 16px", borderRadius: 12,
              textDecoration: "none", fontWeight: 800, fontSize: 14,
              background: "#003353", color: "#ffffff",
            }}>Go to Login</a>
          </div>
        </div>

        <div style={{ marginTop: 20, color: "#6b7280", fontSize: 13, lineHeight: 1.6 }}>
          Choose a personal or business path to continue within the unified LastWish Box app.
        </div>
      </div>
    </div>
  );
}
